export enum EElimsAggregatedStatus {
    AllJobsPending = 1,
    ElimsBatchError,
    ElimsBatchCompleted,
    RegisteredSampleError,
    RegisteredSampleCompleted,
    ValidatedResultError,
    ValidatedResultCompleted,
    FinalizedIntercoError,
    AllJobsCompleted,
}